export default __webpack_public_path__ + "static/media/32.a627e73b.jpg";